module.exports = __webpack_public_path__ + "static/media/Bienvenue-La-voie-de-la-bonne-voix.df638510.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/images/Bienvenue-La-voie-de-la-bonne-voix.pdf
// module id = 1260
// module chunks = 0